import React from 'react';

export const BULK_CONTRIBUTOR_DESCRIPTION =
  'May submit bulk uploads to FastCube (approved by an admin) and run FastID reports, on top of org roles.';

/**
 * Checkbox for `users.is_bulk_contributor`. Shown when the organization is FastCube and the
 * logged-in user is a FastCube member (`is_fastcube`). Looks like a role option so it sits beside them.
 */
function BulkContributorOption({ checked, onChange, disabled = false, compact = false, id = 'bulk-contributor' }) {
  return (
    <label
      htmlFor={id}
      className={`${
        compact ? 'inline-flex w-max shrink-0 items-center' : 'flex items-start'
      } cursor-pointer gap-2 rounded-md border p-2 text-sm ${
        checked ? 'border-[#0062FB] bg-blue-50' : 'border-hairline bg-surface'
      } ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
      title={compact ? undefined : BULK_CONTRIBUTOR_DESCRIPTION}
    >
      <input
        id={id}
        type="checkbox"
        className={compact ? '' : 'mt-0.5'}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={compact ? '' : 'min-w-0'}>
        <span className={`block font-medium text-[#18181B] ${compact ? 'whitespace-nowrap' : ''}`}>Bulk Contributor</span>
        {compact ? null : <span className="block text-xs text-zinc-500">{BULK_CONTRIBUTOR_DESCRIPTION}</span>}
      </span>
    </label>
  );
}

export default BulkContributorOption;
